import React from 'react';
import PropTypes from 'prop-types';
import DisplayUnitContextProvider from '~/modules/resourcing/common/hooks/useDisplayUnitContext';
import {
  ResourcingChartToolbarContext,
  useResourcingChartToolbarContextValue
} from './hooks';

const ResourcingChartToolbarContextProvider = ({
  children,
  project,
  width,
  setSearchCriteria,
  searchCriteria,
  filter,
  sort,
  onSortChange,
  resourceRequestsMinMaxDateAndStatuses,
  resourceAllocationsMinMaxDateAndStatuses,
  handleDisplayUnitChange,
  chartSettings
}) => {
  const contextValues = useResourcingChartToolbarContextValue({
    project,
    width,
    setSearchCriteria,
    searchCriteria,
    filter,
    sort,
    onSortChange,
    resourceRequestsMinMaxDateAndStatuses,
    resourceAllocationsMinMaxDateAndStatuses,
    handleDisplayUnitChange,
    chartSettings
  });

  return (
    <DisplayUnitContextProvider
      defaultDisplayUnit={contextValues.displayUnit}
      onDisplayUnitChange={contextValues.setDisplayUnit}
    >
      <ResourcingChartToolbarContext.Provider value={contextValues}>
        {children}
      </ResourcingChartToolbarContext.Provider>
    </DisplayUnitContextProvider>
  );
};

ResourcingChartToolbarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  project: PropTypes.object.isRequired,
  width: PropTypes.number,
  setSearchCriteria: PropTypes.func,
  filter: PropTypes.object,
  sort: PropTypes.object,
  onSortChange: PropTypes.func,
  resourceRequestsMinMaxDateAndStatuses: PropTypes.object,
  resourceAllocationsMinMaxDateAndStatuses: PropTypes.object,
  searchCriteria: PropTypes.object,
  handleDisplayUnitChange: PropTypes.func,
  chartSettings: PropTypes.object
};

export default ResourcingChartToolbarContextProvider;
